import { History } from 'history'

let history: History
export function getHistory(): History {
  if (!history) {
    // eslint-disable-next-line global-require
    history = require('history').createBrowserHistory()

    if (window.history) {
      window.history.scrollRestoration = 'manual'
    }
  }
  return history
}
